<template>
  <div class="subjectAction">
    <div class="top wbg" v-if='$common.AUTH("accsuer:index")'>
      <div class="group">
        <a-form-model ref="ruleForm" :model="form">
          <div class="label">
            姓名/名称：
            <a-input v-model="form.title" placeholder='请输入姓名/名称' style="width: 167px;"> </a-input>
          </div>
          <div class="btns">
            <a-button type="primary" icon="search" @click="query(1)">查询</a-button>
            <a-button style="min-width: 64px;"  @click="resetList">重置</a-button>
            <a-button v-if="$common.AUTH('accuser:add')" type="primary" ghost icon="plus" @click="addAlert()">新增</a-button>
          </div>
        </a-form-model>
      </div>
    </div>
    <div class="tcon wbg">
      <div class="tableList" v-if='$common.AUTH("accsuer:index")'>
        <a-table rowKey="id" :columns="columns" :data-source="data" :pagination="page" @change="query">
          <div slot="alist" slot-scope="text, record">
            <a v-if="$common.AUTH('accuser:edit')" @click="addAlert(record.id)">修改</a>
          </div>
        </a-table>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
    <a-modal v-model="modalVisible" :title="editId ? '修改原告' : '新增原告'" width="552px" centered @cancel='reset()'>
      <div class="change-subject">
        <a-form-model ref="addForm" :model="subjectForm" :rules="rules" hideRequiredMark :label-col="{ span:5 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="姓名/名称：" prop="title">
            <a-input v-model="subjectForm.title" placeholder='请输入姓名/名称'></a-input>
          </a-form-model-item>
          <a-form-model-item label="证件号码" prop="chinaid">
            <a-input v-model="subjectForm.chinaid" placeholder='请输入证件号码'></a-input>
          </a-form-model-item>
          <a-form-model-item label="业务来源" prop="team_ids">
            <a-select placeholder="请选择业务来源" v-model="subjectForm.team_ids" mode="multiple" show-search :filter-option="filterOption">
              <a-select-option v-for="item in tlist" :key="item.id">{{ item.title }}</a-select-option>
            </a-select>
          </a-form-model-item>

        </a-form-model>
      </div>
      <div slot="footer" class="modal-footer">
        <a-button type="primary" @click="subjectConfirm()">提交</a-button>
        <a-button type="primary" class="cancel" @click="reset()">取消</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getSubject, accuserInfo, accuserEdit, accuserAdd } from '@/server/subjectAction'
import { getAccuserAll } from '@/server/api'
import { teamList } from '@/server/directory'
import Validator from "@/assets/js/yz"
const columns = [
  {
    title: '录入时间',
    key: 'create_time',
    dataIndex: 'create_time',
  },
  {
    title: '姓名/名称',
    key: 'title',
    dataIndex: 'title',
  },
  {
    title: '证件号码',
    key: 'chinaid',
    dataIndex: 'chinaid',
  },
  {
    title: '操作',
    key: 'alist',
    dataIndex: 'alist',
    scopedSlots: { customRender: 'alist' },
    width: 100
  },
];
export default {
  data() {
    return {

      selectedRowKeys: [],
      form: {
        title: '',
      },
      editId: '',
      modalVisible: false,
      columns,
      data: [],
      subjectForm: {
        title: '',
        chinaid: '',
        team_ids: []
      },
      tlist: [],
      rules: {
        title: [
          { required: true, message: '请输入姓名/名称', trigger: 'blur' },
          { message: '姓名/名称只能是汉字、字母和数字', trigger: 'blur', validator: Validator.companyName },
        ],
        chinaid: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
        ],
        team_ids: [
          { required: true, message: '请选择业务来源', trigger: 'change' },
        ]
      },
      page: {
        current: 1,
        pageSize: 10,
        // showQuickJumper: true,
        // showSizeChanger: true,
        showQuickJumper: true,
        showLessItems: true,
        total: 0,
        showTotal(total) {
          return `小计 ${total} `
        }
      },
      groupData: this.$store.state.user ? this.$store.state.user.link_group : []
    }
  },
  created() {
    teamList({ limit: 100 }).then(e => {
      this.tlist = e.list
    })

    this.query()
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      // console.log(e)
      if (e.keyCode == 13) {
        _this.query()
      }
    }
  },
  methods: {
    reset() {
      this.$refs.addForm.resetFields()
      this.modalVisible = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    query(val) {
      if (val) {
        if (typeof val === 'object') {
          this.page.current = val.current
          this.page.pageSize = val.pageSize
        } else {
          this.page.current = 1
        }
      }
      let obj = Object.assign({
        page: this.page.current,
        limit: this.page.pageSize
      }, this.form);
      getSubject(obj).then((res) => {
        this.data = res.list
        this.page.total = res.count
      })
    },
    resetList(){
      this.page.current = 1
      this.page.pageSize = 10
      this.form.title = ''
      this.query()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    addAlert(id) {
      if (id) {
        this.editId = id
        accuserInfo({
          id: id
        }).then((res) => {
          this.modalVisible = true
          this.$nextTick(() => {
            this.subjectForm.chinaid = res.accuser.chinaid
            this.subjectForm.title = res.accuser.title;
            this.subjectForm.team_ids = res.accuser.team.map(ele => {
              return ele.team.id
            });
          })
        })
      } else {
        this.editId = '';
        this.modalVisible = true
        this.$nextTick(() => {
          this.$refs.addForm.resetFields()
        })
      }
    },
    subjectConfirm() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.editId) {
            accuserEdit(Object.assign(this.subjectForm, { id: this.editId })).then((res) => {
              this.$message.success({ content: '修改成功' });
              this.modalVisible = false
              this.query();
            })
          } else {
            accuserAdd(this.subjectForm).then((res) => {
              this.$message.success({ content: '添加成功' });
              this.modalVisible = false
              this.query();
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/assets/css/topForm");
// .ant-btn {
//   border-color: #1d8bfe;
//   color: #1d8bfe;
// }
// .ant-btn-primary {
//   color: #ffffff;
//   border-color: #1d8bfe;
//   background-color: #1d8bfe;
// }
.tcon {
  padding: 0 20px;
  min-height: 760px;
  .tableList {
    .line {
      display: inline-block;
      width: 1px;
      height: 14px;
      background-color: #dbdcde;
      margin: 0 10px;
      vertical-align: middle;
    }
  }
}
/deep/ .ant-modal-header {
  padding: 20px 40px;
}
/deep/ .ant-modal-body {
  padding: 24px 40px 0;
}
/deep/ .ant-modal-footer {
  border-top: none;
  padding-bottom: 30px;
}
.modal-footer {
  text-align: center;
  button {
    width: 90px;
  }
  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
</style>
